import React from 'react';
import Search from '../../Components/Search';
import ListView from './ListView';
import filterSearchConditions from './filterSearchConditions';

const Customers = () => {
    return <Search hasConditionsFilter={filterSearchConditions} persist="customers-search">
        <ListView />
    </Search>
}

export default Customers;
